export default [
    {
      path: '/packageA/loan_computer/main',
      name: 'packageA/loan_computer/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/main')
    },
    {
      path: '/packageA/loan_computer/loan_rate',
      name: 'packageA/loan_computer/loan_rate',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/loan_rate')
    },
    {
      path: '/packageA/loan_computer/result/main',
      name: 'packageA/loan_computer/result/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/result/main')
    },
    {
      path: '/packageA/loan_computer/share/result/history',
      name: 'packageA/loan_computer/share/result/history',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/share/result/history')
    },
    {
      path: '/packageA/loan_computer/share/help',
      name: 'packageA/loan_computer/share/help',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/share/help')
    },
    {
      path: '/packageA/taxes_calculate/main',
      name: 'packageA/taxes_calculate/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/taxes_calculate/main')
    },
    {
      path: '/packageA/taxes_calculate/result',
      name: 'packageA/taxes_calculate/result',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/taxes_calculate/result')
    },
    {
      path: '/packageA/prepayment_calc/main',
      name: 'packageA/prepayment_calc/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/prepayment_calc/main')
    },
    {
      path: '/packageA/prepayment_calc/main',
      name: 'packageA/prepayment_calc/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/prepayment_calc/main')
    },
    {
      path: '/packageA/loan_computer/loan_rate',
      name: 'packageA/loan_computer/loan_rate',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/loan_rate')
    },
    {
      path: '/packageA/prepayment_calc/process',
      name: '/packageA/prepayment_calc/process',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/prepayment_calc/process')
    },
    {
      path: '/packageA/prepayment_calc/result',
      name: '/packageA/prepayment_calc/result',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/prepayment_calc/result')
    },
    {
      path: '/packageA/prepayment_calc/help',
      name: '/packageA/prepayment_calc/help',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/prepayment_calc/help')
    },
    {
      path: '/packageA/loan_computer/main',
      name: '/packageA/loan_computer/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/loan_computer/main')
    },
    {
      path: '/packageA/material/main',
      name: '/packageA/material/main',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/material/main')
    },
    {
      path: '/packageA/material/house_purchase',
      name: '/packageA/material/house_purchase',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/material/house_purchase')
    },
    {
      path: '/pages/packageA/contact_us/main',
      name: '/contact_us',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/contact_us/main')
    },
    {
      path: '/pages/packageA/contact_us/cooperation/main',
      name: '/contact_us/cooperation',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/contact_us/cooperation/main')
    },
    {
      path: '/pages/packageA/contact_us/join/main',
      name: '/contact_us/join',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/contact_us/join/main')
    },
    {
      path: '/pages/packageA/contact_us/service/main',
      name: '/contact_us/service',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/contact_us/service/main')
    },
    {
      path: '/pages/packageA/residence_points/main',
      name: 'residence_points',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/residence_points/main')
    },
    {
      path: '/pages/packageA/residence_points/exam',
      name: 'residence_points_exam',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/residence_points/exam')
    },
    {
      path: '/pages/packageA/residence_points/result',
      name: 'residence_points_result',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/residence_points/result')
    },
    {
      path: '/pages/packageA/min-app/main',
      name: 'min-app',
      component: () => import(/* webpackChunkName: "packageA" */ '../views/packageA/min-app/main')
    }
]